export const hasErrors = (fieldsError) => {
  return Object.keys(fieldsError).some((field) => fieldsError[field])
}

export const socials = [
  'Facebook',
  'Discord',
  'Google',
  'Instagram',
  'Line',
  'LinkedIn',
  'QQ',
  'Reddit',
  'Signal',
  'Skype',
  'Snapchat',
  'Telegram',
  'TikTok',
  'Twitter',
  'Viber',
  'VK',
  'WeChat',
  'WhatsApp',
  'Youtube',
  'Other',
]

export const socialIcons = [
  'facebook',
  'discord',
  'google',
  'instagram',
  'line',
  'linkedin',
  'reddit',
  'skype',
  'snapchat',
  'telegram',
  'tiktok',
  'twitter',
  'viber',
  'vk',
  'whatsapp',
  'youtube',
]
